import type { FC } from 'react';

import cn from 'classnames';

interface SpinnerProps {
  /** Size comes from the caller (e.g. `size-5`); `cn` can't resolve competing size utilities. */
  className?: string;
  /** Announces the spinner as a named status element; omit when a parent already carries the status semantics. */
  label?: string;
}

export const Spinner: FC<SpinnerProps> = ({ className = 'size-6', label }) => {
  const spinnerClass = cn('animate-spin rounded-full border-2 border-black/10 border-t-black/50', className);

  if (label) return <div role="status" aria-label={label} className={spinnerClass} />;
  return <div aria-hidden="true" className={spinnerClass} />;
};
